var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "商品名",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入商品名模糊查询",
                                      "allow-clear": "",
                                    },
                                    model: {
                                      value: _vm.queryParam.search,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "search", $$v)
                                      },
                                      expression: "queryParam.search",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "售卖",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        placeholder: "全部",
                                        allowClear: "",
                                      },
                                      model: {
                                        value: _vm.queryParam.sellable,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "sellable",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.sellable",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "1" } },
                                        [_vm._v("售卖中")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "0" } },
                                        [_vm._v("已停售")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                            _c(
                              "span",
                              {
                                staticClass: "table-page-search-submitButtons",
                                staticStyle: {
                                  float: "left",
                                  overflow: "hidden",
                                },
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.searchQuery },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: { click: _vm.searchReset },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleBind },
                        },
                        [_vm._v("新增绑定")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("a-table", {
                ref: "table",
                attrs: {
                  size: "middle",
                  bordered: "",
                  rowKey: "id",
                  columns: _vm.columns,
                  dataSource: _vm.dataSource,
                  pagination: _vm.ipagination,
                  scroll: _vm.scroll,
                  loading: _vm.loading,
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "imgSlot",
                    fn: function (text, record) {
                      return [
                        _vm.getImgUrl(record.imgName)
                          ? _c("img", {
                              staticClass: "goods-thumb",
                              attrs: { src: _vm.getImgUrl(record.imgName) },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                  {
                    key: "sellableSlot",
                    fn: function (text, record) {
                      return [
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: record.sellable === "1",
                            loading:
                              _vm.switchingKey === record.id + "-sellable",
                          },
                          on: {
                            click: () => _vm.toggleFlag(record, "sellable"),
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "soldOutSlot",
                    fn: function (text, record) {
                      return [
                        _c("a-switch", {
                          attrs: {
                            size: "small",
                            checked: record.soldOut === "1",
                            loading:
                              _vm.switchingKey === record.id + "-soldOut",
                          },
                          on: {
                            click: () => _vm.toggleFlag(record, "soldOut"),
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "sortSlot",
                    fn: function (text, record) {
                      return [
                        _c("a-input-number", {
                          staticStyle: { width: "70px" },
                          attrs: { min: 0, precision: 0 },
                          on: {
                            focus: () => _vm.onSortFocus(record),
                            blur: () => _vm.saveSort(record),
                          },
                          model: {
                            value: record.sort,
                            callback: function ($$v) {
                              _vm.$set(record, "sort", $$v)
                            },
                            expression: "record.sort",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handleOptions(record)
                                },
                              },
                            },
                            [_vm._v("选项设置")]
                          ),
                          _c("a-divider", { attrs: { type: "vertical" } }),
                          _vm.btnEnableList.indexOf(1) > -1
                            ? _c(
                                "a-popconfirm",
                                {
                                  attrs: {
                                    title:
                                      "删除后该商品的选项组/值将一并删除，确定删除吗？",
                                  },
                                  on: {
                                    confirm: () => _vm.handleDelete(record.id),
                                  },
                                },
                                [_c("a", [_vm._v("删除")])]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
              _c("goods-bind-modal", {
                ref: "bindModal",
                on: { ok: _vm.modalFormOk },
              }),
              _c("option-groups-modal", { ref: "optionModal" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }